import styled, { css } from "styled-components";

import { size } from "~/styles/screen";

export const Container = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 60%;
  background-color: #fff;
  padding: 30px;
  border-radius: 4px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  margin-bottom: 20px;

  @media screen and (max-width: ${size.small}) {
    width: 90%;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 80px;
  margin-bottom: 25px;
`;

export const QuestionContainer = styled.div`
  display: flex;
  position: relative;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
`;

export const Question = styled.h1`
  font-size: 22px;
  text-align: left;
  font-weight: 900;
  font-family: "Roboto Slab";
  line-height: 29.01px;
  color: black;
  padding: 0 10px;
  @media screen and (max-width: ${size.small}) {
    & {
      font-size: 18px;
    }
  }
`;

export const Answer = styled.text`
  font-size: 18px;
  text-align: center;
  font-weight: 400;
  font-family: "Montserrat";
  line-height: 21.6px;
  color: black;
  @media screen and (max-width: ${size.small}) {
    & {
      font-size: 16px;
    }
  }
`;

interface CSSProps {
  collapsed: boolean;
}

export const AnswerContainer = styled.div`
  padding: 0 15px;
`;

export const CollapsibleDiv = styled.div<CSSProps>`
  overflow: hidden;
  max-height: 5000px;
  transition: max-height 0.5s cubic-bezier(1, 0, 1, 0);

  ${(props) =>
    props.collapsed &&
    css`
      max-height: 0;
      transition: max-height 0.85s cubic-bezier(0, 1, 0, 1);
    `}
`;
